export const MIN_PITCH_FLOOR = 30.0;
export const MIN_ANALYSIS_PITCH = 75.0;
export const MAX_ANALYSIS_PITCH = 500.0;
export const MIN_ANALYSIS_TIME = 0.0;
export const MAX_ANALYSIS_TIME = 1.0;
export const SPEAKER_LIMIT = 4;
export const MIN_IMAGE_XPERC = 351.0 / 2800.0;
export const MAX_IMAGE_XPERC = 2513.0 / 2800.0;
export const AUDIO_IMG_WIDTH = 723;
export const AUDIO_WIDTH = AUDIO_IMG_WIDTH - AUDIO_IMG_WIDTH * MIN_IMAGE_XPERC - AUDIO_IMG_WIDTH * (1 - MAX_IMAGE_XPERC);
export const AUDIO_IMG_HEIGHT = 500;
export const SYLLABLE_TEXT = "";
export const SEPARATOR_TEXT = "";
